import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import ProceedToTest from './pages/ProceedToTest';
import ProgressPath from './pages/ProgressPath';
import Quiz from './pages/Quiz';
import Results from './pages/Results';
import PollingZone from './pages/PollingZone';
import NotFound from './pages/NotFound';
import { trackPageView } from './services/analytics';

// Component to track page views on route changes
const PageViewTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view on route change
    const pageTitles = {
      '/': 'Home',
      '/start': 'Proceed to Test',
      '/progress': 'Progress Path',
      '/quiz': 'Quiz',
      '/results': 'Results',
      '/polling': 'Polling Zone'
    };
    const title = pageTitles[location.pathname] || 'Unknown Page';
    trackPageView(location.pathname, `Educado AI - ${title}`);
  }, [location]);
  
  return null;
};

function App() {
  return (
    <Router>
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/start" element={<ProceedToTest />} />
        <Route path="/progress" element={<ProgressPath />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/results" element={<Results />} />
        <Route path="/polling" element={<PollingZone />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
